import { nanoid } from 'nanoid';

export function handleEpiHiddenInput(input) {
  if (input) {
    input.removeAttribute('autocomplete');
  }
}

export function handleEpiDuplicatedId(section) {
  if (section) {
    const id = `id-${nanoid()}`;
    section.id = id;
  }
}

export function handleEpiRadioGroup(group) {
  if (group) {
    const hasRadio = group._$('input[type="radio"]');
    if (hasRadio) {
      group.setAttribute('role', 'radiogroup');
    }
  }
}

export function handleEpiInputRadio(radio) {
  const id = `id-${nanoid()}`;
  const labelDiv = radio.parentNode;
  const label = labelDiv.querySelector('label');
  const labelParent = labelDiv.parentNode;
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormChoice__Input--Radio-Wrapper');
  labelParent.insertBefore(wrapper, labelDiv);
  wrapper.appendChild(labelDiv);
  wrapper.insertBefore(radio, labelDiv);
  radio.id = id;
  label.htmlFor = id;
}

export function handleEpiInputCheckbox(checkbox) {
  const id = `id-${nanoid()}`;
  const labelDiv = checkbox.parentNode;
  const label = labelDiv.querySelector('label');
  const labelParent = labelDiv.parentNode;
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormChoice__Input--Checkbox-Wrapper');
  labelParent.insertBefore(wrapper, labelDiv);
  wrapper.appendChild(labelDiv);
  wrapper.insertBefore(checkbox, labelDiv);
  checkbox.id = id;
  label.htmlFor = id;
}

export function handleEpiDropdown(dropdown) {
  const wrapper = document.createElement('div');
  wrapper.classList.add('FormSelection__Select-Wrapper');
  dropdown.parentNode.insertBefore(wrapper, dropdown);
  wrapper.appendChild(dropdown);
}

export function handleEpiSimpleInputs(input) {
  input._on('change', handleInput);
  input._on('input', handleInput);
}

function handleInput(e) {
  if (e.target.value) {
    e.target.parentNode.classList.add('Form__Element--Filled');
  } else {
    e.target.parentNode.classList.remove('Form__Element--Filled');
  }
}
